// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__DgFuM","search":"Settings_search__2mbJs","filter":"Settings_filter__A9Eih"};